export const QA_NAME_OVERVIEW_APPROVAL_VIEW = 'rentalPortalOverviewApprovalView'

export const QA_NAME_OVERVIEW_APPROVAL_APPROVE =
  'rentalPortalOverviewApprovalApprove'
